// components/SEO.js
import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  keywords = [],
  slug,
  image,
}) {
  const siteUrl = "https://zeroequalone.com";
  const url = `${siteUrl}/articles/${slug}`;
  const imageUrl = image || `${siteUrl}/assets/default-cover.png`;

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title} | ZeroEqualOne</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(", ")} />

      {/* Open Graph (Facebook/LinkedIn) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imageUrl} />

      {/* Twitter/X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
}
